import React from "react";
import { Pressable, PressableProps, StyleSheet, View } from "react-native";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { PdChevronDown, PdChevronUp } from "../Icons";
import { tPressableState } from "../types";

interface iPdAccordionItemContext {
  isOpened?: boolean;
}

export type tPdAccordion = {
  defaultName?: string;
};

const PdAccordionItemContext = React.createContext<Partial<iPdAccordionItemContext>>({});

export const PdAccordionItem: React.FC<{ isOpened?: boolean }> = ({ isOpened, children }) => {
  return (
    <PdAccordionItemContext.Provider value={{ isOpened }}>
      <View style={styles.pdAccordionItem}>{children}</View>
    </PdAccordionItemContext.Provider>
  );
};

export const PdAccordionButton: React.FC<PressableProps> = ({ children, ...rest }) => {
  return (
    <Pressable {...rest}>
      {({ pressed, hovered }: tPressableState) => (
        <View style={[styles.pdAccordionButton, hovered ? styles.bgGrayLight : {}, pressed ? styles.opacityMd : {}]}>
          {children}
        </View>
      )}
    </Pressable>
  );
};

export const PdAccordionPanel: React.FC = ({ children }) => {
  const { isOpened } = React.useContext(PdAccordionItemContext);
  if (!isOpened) return null;
  return <View style={styles.pb4}>{children}</View>;
};

export const PdAccordionIcon: React.FC = () => {
  const { isOpened } = React.useContext(PdAccordionItemContext);
  const SvgIconComp = isOpened ? PdChevronUp : PdChevronDown;
  return <SvgIconComp style={styles.pdAccordionIcon} />;
};

const styles = StyleSheet.create({
  bgGrayLight: {
    backgroundColor: kColors.gray50,
  },
  opacityMd: {
    opacity: 0.6,
  },
  pb4: {
    paddingBottom: kStyleConst.kSpacing * 4,
  },
  pdAccordionButton: {
    alignItems: "center",
    flexDirection: "row",
    paddingVertical: kStyleConst.kSpacing * 3,
  },
  pdAccordionIcon: {
    color: kColors.brandDarkRed500,
    height: 10,
    marginLeft: kStyleConst.kSpacing,
    width: 10,
  },
  pdAccordionItem: {
    borderBottomColor: kColors.brandDark,
    borderBottomWidth: 1,
  },
});
